import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../helpers/axios";
const { timeConstants } = require("./constants");

export const fetchWriteoffsByAdminId = (
  adminId,
  fromDate,
  toDate,
  matterId,
  user
) => {
  return async (dispatch) => {
    // console.log("Request Data", adminId, fromDate, toDate, matterId, user);
    dispatch({ type: timeConstants.FETCH_WRITEOFFS_REQUEST_BY_ADMIN });
    await axiosInstance
      .get(`/writeoffs/getWriteoffHoursByAdmin`, {
        params: {
          adminId,
          fromDate,
          toDate,
          matterId,
          user,
          limit: 0,
          page: 0,
        },
      })
      .then(async (response) => {
        // return response.data
        // console.log("Response Data for WriteOffs Data", response);
        dispatch({
          type: timeConstants.FETCH_WRITEOFFS_SUCCESS_BY_ADMIN,
          payload: {
            writeoffHours: response.data.workHours,
            totalWriteoffCount: response.data.totalCount,
          },
        });
      })
      .catch((error) => {
        // console.log(error);
        dispatch({
          type: timeConstants.FETCH_WRITEOFFS_FAILURE_BY_ADMIN,
          payload: {
            error: JSON.stringify(error.response),
          },
        });
        toast.error({
          text1: JSON.stringify(error.response),
        });
      });
  };
};
